import * as LucideIcons from 'lucide-react';
import { MessageCircle, Megaphone, Shield, Globe, Lock } from 'lucide-react';

export const renderLucideIcon = (iconName: string, size: number = 20) => {
  const IconComponent = (LucideIcons as any)[iconName];
  if (!IconComponent) return null;
  return <IconComponent size={size} width={size} height={size} style={{ flexShrink: 0 }} />;
};

export const getInteractionIcon = (interaction: string, size: number = 20) => {
  const iconMap: Record<string, { Icon: any; color: string }> = {
    'Full': { Icon: MessageCircle, color: '#059669' },
    'Announce Only': { Icon: Megaphone, color: '#6b7280' },
    'Administrative': { Icon: Shield, color: '#3b82f6' },
  };

  const config = iconMap[interaction];
  if (!config) return null;

  const { Icon, color } = config;
  return <Icon size={size} style={{ color }} />;
};

export const getVisibilityIcon = (visibility: string, size: number = 20) => {
  const iconMap: Record<string, { Icon: any; color: string }> = {
    'public': { Icon: Globe, color: '#059669' },
    'internal': { Icon: Lock, color: '#6b7280' },
  };

  const config = iconMap[visibility.toLowerCase()];
  if (!config) return null;

  const { Icon, color } = config;
  return <Icon size={size} style={{ color }} />;
};
